(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure(); this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starlit-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      if (!this.headerBounds) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      if (!this.disclosures) return;
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  /* === Hero carousel logic === */
  class HeaderHeroCarousel {
    constructor(container) {
      this.container = container;
      this.slides = Array.from(container.querySelectorAll('.header-hero-slide'));
      this.currentIndex = 0;
      this.interval = parseInt(container.dataset.interval, 10) || 5000;
      this.transition = container.dataset.transition || 'fade';
      this.timer = null;

      if (this.slides.length <= 1) return;

      this.applyTransitionMode();
      this.start();
    }

    applyTransitionMode() {
      this.container.classList.remove('transition-fade', 'transition-slide');
      if (this.transition === 'slide') {
        this.container.classList.add('transition-slide');
      } else {
        this.container.classList.add('transition-fade');
      }
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      if (!this.slides.length) return;
      const current = this.slides[this.currentIndex];
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      const next = this.slides[this.currentIndex];

      if (current) current.classList.remove('is-active');
      if (next) next.classList.add('is-active');
    }
  }

  function initHeaderHeroCarousels(scope) {
    const root = scope || document;
    root.querySelectorAll('.header-hero-carousel').forEach((el) => {
      if (!el._heroCarouselInstance) {
        el._heroCarouselInstance = new HeaderHeroCarousel(el);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeaderHeroCarousels(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('section-header')) {
      initHeaderHeroCarousels(event.target);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starlit-hero"] && !Shopify.designMode) return;
  try {
    
  class SSHeroMediaCarousel {
    constructor(container) {
      this.container = container;
      this.slides = Array.from(container.querySelectorAll('.ss-hero__media-slide'));
      this.dots = Array.from(container.querySelectorAll('.ss-hero__media-dot'));
      this.currentIndex = 0;
      this.interval = parseInt(container.dataset.interval, 10) || 5000;
      this.transition = container.dataset.transition || 'fade';
      this.timer = null;

      if (this.slides.length <= 1) return;

      this.applyTransitionMode();
      this.bindDots();
      this.updateDots();
      this.start();
    }

    applyTransitionMode() {
      this.container.classList.remove('transition-fade', 'transition-slide');
      if (this.transition === 'slide') {
        this.container.classList.add('transition-slide');
      } else {
        this.container.classList.add('transition-fade');
      }
    }

    bindDots() {
      if (!this.dots || !this.dots.length) return;
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.goTo(index);
          this.start(); // restart timer from this slide
        });
      });
    }

    updateDots() {
      if (!this.dots || !this.dots.length) return;
      this.dots.forEach((dot, index) => {
        const isCurrent = index === this.currentIndex;
        dot.setAttribute('aria-current', isCurrent ? 'true' : 'false');
        if (isCurrent) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    goTo(index) {
      if (!this.slides.length) return;

      const normalized = ((index % this.slides.length) + this.slides.length) % this.slides.length;
      if (normalized === this.currentIndex) return;

      const current = this.slides[this.currentIndex];
      const next = this.slides[normalized];

      if (current) current.classList.remove('is-active');
      if (next) next.classList.add('is-active');

      this.currentIndex = normalized;
      this.updateDots();
    }

    next() {
      this.goTo(this.currentIndex + 1);
    }
  }

  function initSSHeroCarousels(scope) {
    const root = scope || document;
    root.querySelectorAll('.ss-hero__media-carousel').forEach((el) => {
      if (!el._ssHeroCarouselInstance) {
        el._ssHeroCarouselInstance = new SSHeroMediaCarousel(el);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initSSHeroCarousels(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('ss-hero-section')) {
      initSSHeroCarousels(event.target);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
